module.exports = __webpack_public_path__ + "img/image-divide-white.71a474e8.svg";